module.exports = __webpack_public_path__ + "media/sub3-5-1.659b9154.mp4";